import { CARD_GROUP_FORM } from './form-cardgroup-types';
import { listCustCGWidget } from '../../widgets/cust-cg-list-widget';
import { displayLinkedCustCGWidget } from '../../widgets/linked-cust-cg-widget';

import { ICustomerSearch } from '../../../models/customer.interface';
import SearchCustomers from '../../../routes/customer-search';

/**
 * Function to handle customer search and display results
 * 
 * @param {HTMLElement} buttonEle search button element
 * @param {HTMLElement} inputEle search keyword input
 * @param {HTMLElement} resultContainer container to display the selected element
 * @param {object} linked currently linked customers
 *
 * @returns void
 */
export const getCustomerList = (buttonEle: HTMLElement, inputEle: HTMLInputElement, resultContainer: HTMLElement, linked?: any) => {
  if (!buttonEle) return;
  buttonEle.addEventListener('click', async () => {
    resultContainer.innerHTML = `<span>Searching for customers...</span>`;

    const { body } = await SearchCustomers(inputEle.value);
    resultContainer.innerHTML = '';

    let avalCustomers: ICustomerSearch[] = body.filter((item: any) => {
      if (linked != undefined) {
        return linked.every((item2: any) => item2.customerId != item.customerId)
      } else {
        return item;
      }        
    });

    const searchResults = avalCustomers.filter((item: any) => {
      return item.customerName.toLowerCase().includes(inputEle.value.toLowerCase());
    });
    
    if(Object.keys(searchResults).length === 0) {
      resultContainer.innerHTML = '<span>No customers found!</span>';
    }

    listCustCGWidget(resultContainer, searchResults);
    getSelectedCustomer(CARD_GROUP_FORM.cgSelectedCustContainer, CARD_GROUP_FORM.cgResults);
  });  
}

/**
 * Function get the selected customer and display them in the left column
 * 
 * @param {HTMLElement} avalContainer the available customer's container element
 * @param {HTMLElement} resultsContainer the selected customer container
 */
const getSelectedCustomer = ( avalContainer: HTMLElement, resultsContainer: HTMLElement ) => {
  avalContainer?.addEventListener('click', e => {
    let data: ICustomerSearch[] = [];
    const target = e.target as HTMLElement;

    if(target != this && target.classList.contains('get-selected-element')) {
      data.push({ customerId: +target.dataset.id!, customerName: target.dataset.name!, partnerName: target.dataset.partner! });  
      displayLinkedCustCGWidget( resultsContainer, data );       
      target.parentElement!.remove();
    } 
  });
}

/**
 * Removes currently linked customers to individual card group
 * 
 * @param {string} accessElement array of elements
 * @param {any} id unique number for target element
 */
export const removeCardGroupCustomerLink = (accessElement: string, id: any) => {
  let getAccessList = document.querySelector(accessElement) as HTMLElement;
  let removeEle = document.querySelector('.ele_access_' + id);
  let elementData: ICustomerSearch[] = [];

  elementData.push({
    customerId: +removeEle?.getAttribute('data-id')!,
    customerName: removeEle?.getAttribute('data-name')!,
    partnerName: removeEle?.getAttribute('data-partner')!
  });

  if(!getAccessList) return;
  getAccessList.addEventListener('click', () => {
    listCustCGWidget(CARD_GROUP_FORM.cgSelectedCustContainer, elementData);
    removeEle?.remove();
  });
}